module.exports = __webpack_public_path__ + "static/media/dreamstime.7c911647.png";